import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import style from './UserName.scss';

const cn = bemCssModules(style, 'UserName');

export type TUserName = {
  firstName?: string | null;
  firstNameEn?: string | null;
};

const UserName: CustomFC<TUserName> = ({ firstName = '', firstNameEn = '' }) => {
  const { t } = useTranslation();
  const userFirstName = firstNameEn || firstName;
  const name = userFirstName ? `, ${userFirstName}` : '';
  const text = `${t('public.hello')}${name}`;

  return <div className={cn(null, ['h1'])}>{text}</div>;
};

export default UserName;
